//  ========================================================= IPFS ======================================================= //

import axios from "axios";
import { useState } from "react";
import Environment from "../../utils/Environment";

let token =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiJkY2M5MGVjNC04NWYwLTRjZjktODg3ZS03NmM5MzJiMjMzYjkiLCJlbWFpbCI6InVzbWFuLm1hbGlrbnUxM0BnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGluX3BvbGljeSI6eyJyZWdpb25zIjpbeyJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MSwiaWQiOiJGUkExIn0seyJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MSwiaWQiOiJOWUMxIn1dLCJ2ZXJzaW9uIjoxfSwibWZhX2VuYWJsZWQiOmZhbHNlLCJzdGF0dXMiOiJBQ1RJVkUifSwiYXV0aGVudGljYXRpb25UeXBlIjoic2NvcGVkS2V5Iiwic2NvcGVkS2V5S2V5IjoiMmJiZDFkZmM3YWI2ZDg0MzEwY2UiLCJzY29wZWRLZXlTZWNyZXQiOiI3ODNhMmMyOGY5Yzc4OGRmNGE3ZDQ4YjU2N2NjNzUwYjRkMWZjMDM0OWI0MGFjYzYwZjhjOTQ1ZmM4ZmI3MDE4IiwiZXhwIjoxNzYyODY5Mzk4fQ.hIRx3GiuH5vbStB6kuLL4Z9tiDRTyuRmPi4SPTOOi5I";
const apikey = "2bbd1dfc7ab6d84310ce";
const secretapikey = "783a2c28f9c788df4a7d48b567cc750b4d1fc0349b40acc60f8c945fc8fb7018";

// const [loader, setLoader] = useState(false);
// const [loaderMessage, setLoaderMessage] = useState("");
// const [metaHash, setMetaHash] = useState("");

// const [existingHashes, setexistingHashes] = useState(null);

const handleImageChange = async (inputFile) => {
    console.log("Starting image upload process", inputFile);

    const files = Array.isArray(inputFile) || inputFile.length
        ? inputFile
        : [inputFile];

    const existingHashes111 = [];

    try {
        for (let i = 0; i < files.length; i++) {
            const formData = new FormData();
            formData.append("file", files[i]);

            const options = { pinataOptions: { cidVersion: 0 } };
            formData.append("pinataOptions", JSON.stringify(options));

            const response = await fetch(
                "https://api.pinata.cloud/pinning/pinFileToIPFS",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    body: formData,
                }
            );

            if (!response.ok) {
                throw new Error(`Failed to upload image ${i + 1}`);
            }

            const { IpfsHash } = await response.json();
            if (IpfsHash) {
                existingHashes111.push(IpfsHash);
                console.log(`Image ${i + 1} uploaded: ${IpfsHash}`);
            }
        }

        if (existingHashes111.length > 0) {
            localStorage.setItem("fileHashes", JSON.stringify(existingHashes111));
        }

        return existingHashes111;
    } catch (error) {
        console.error("Error uploading image(s):", error);
    }
};

export const uploadProofOnIPFS = async (account, taskData, message, file, proofArray = null) => {
    try {
        const uploadedMetadataUrls = [];
        const metadataHashes = [];
        console.log(account, taskData, message, file, proofArray, "proofArray in UploadProofOnIPFS...");

        let metadataObj;

        if (proofArray && Array.isArray(proofArray)) {
            // ✅ Use the provided proofArray directly
            metadataObj = proofArray;
        }
        else if (message == null && file == null && taskData?.winnerSelected == false) {
            metadataObj = [{
                taskTitle: taskData?.title,
                taskDetails: taskData?.description,
                walletAddress: account,
                taskId: taskData?.contractTaskId,
                userId: taskData?.user?.id,
                userName: taskData?.user?.name,
                partyAddress: taskData?.user?.walletAddress,
                taskRequirements: taskData?.requirements,
                isActionCreator: true
            }];
        }
        else {
            // 🟡 Process file and generate IPFS image URL array
            const ipfsImgres = await handleImageChange(file);
            const existingHashes = JSON.parse(localStorage.getItem("fileHashes") || "[]");

            const ipfsImageUrlArray = existingHashes.map((hash) => ({
                ipfsImageURI: `ipfs://${hash}/`,
            }));

            // ✅ Construct metadata from taskData and uploaded image
            metadataObj = [{
                taskTitle: taskData?.title,
                ProofMessege: message,
                ProofData: ipfsImageUrlArray,
                proofImageName: file ? file[0]?.name : "",
                taskDetails: taskData?.description,
                walletAddress: account,
                taskId: taskData?.contractTaskId,
                userId: localStorage?.getItem('userId'),
                userName: localStorage?.getItem('userName'),
                taskRequirements: taskData?.requirements,
                // taskCreatorAddress: taskData?.user?.walletAddress,
                partyAddress: taskData?.participants[0]?.status == "winner" ? taskData?.participants[0]?.user?.walletAddress : account
            }];
        }

        // 📦 Convert to JSON and upload
        const metadataJson = JSON.stringify(metadataObj);
        const metadataBlob = new Blob([metadataJson], { type: "application/json" });
        const metadataFile = new File([metadataBlob], `proof-metadata-${Date.now()}.json`, {
            type: "application/json",
        });

        const formDataMetadata = new FormData();
        formDataMetadata.append("file", metadataFile, metadataFile.name);

        formDataMetadata.append(
            "pinataMetadata",
            JSON.stringify({
                name: metadataObj[0]?.taskTitle || "proof-data",
                keyvalues: {
                    walletAddress: metadataObj[0]?.walletAddress || "",
                    taskId: metadataObj[0]?.taskId?.toString() || "",
                    userId: metadataObj[0]?.userId?.toString() || "",
                },
            })
        );

        formDataMetadata.append("pinataOptions", JSON.stringify({ cidVersion: 0 }));

        const metadataUploadResponse = await axios.post(
            "https://api.pinata.cloud/pinning/pinFileToIPFS/",
            formDataMetadata,
            {
                headers: {
                    pinata_api_key: `${apikey}`,
                    pinata_secret_api_key: `${secretapikey}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        const metadataIpfsHash = metadataUploadResponse.data.IpfsHash;
        const metadataIpfsUrl = `${Environment?.IPFS_URI}${metadataIpfsHash}/`;

        uploadedMetadataUrls.push(metadataIpfsUrl);
        metadataHashes.push(metadataIpfsHash);

        localStorage.setItem("metadataHashes", JSON.stringify(metadataHashes));

        return metadataHashes;
    } catch (error) {
        console.error("❌ Error during metadata upload:", error?.response?.data || error.message);
        return null;
    }
};

//  ========================================================= IPFS ======================================================= //